import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("iframe", {
    class: "w-full",
    style: {"aspect-ratio":"16 / 9"},
    src: _ctx.src,
    frameborder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: "",
    loading: "laze"
  }, null, 8 /* PROPS */, _hoisted_1))
}